module.exports = __webpack_public_path__ + "img/404.011fe703.png";